/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IYoutubeEmbedViewProps } from './youtube-embed';

export default (props: IYoutubeEmbedViewProps) => {
    if (!props.config.videoCode){
        return '';
    }
    const url = "https://www.youtube-nocookie.com/embed/" + props.config.videoCode;
    return (
        <div className='youtube-embed'><iframe width="560" height="315" 
            src={url}
            title="YouTube video player" 
            frameBorder="0"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen></iframe>
        </div>
    );
};
